module.exports = __webpack_public_path__ + "img/D12.f9223de1.svg";